<template>
    <div v-if="rules && (isSearching || searchError ||
                (player?.nachname && player.passNumber?.length === 6 ) )"
                :class="searchError?.code==='tooMany'?'mt-3':'border rounded mt-3 pa-2'">
        <div v-if="searchError?.code!=='tooMany'">
            Pass-Nr. {{player.passNumber}} <span v-if="isSearching"> wird gesucht!</span>
            <v-icon v-if="!enterManually && player.nachname" color="success" size="small">mdi-check</v-icon>
        </div>
        <v-progress-linear v-if="isSearching" indeterminate color="primary" class="my-2"/>
        <div v-if="player">
            <div class="font-weight-bold">{{player.nachname}} {{player.vorname}}</div>
            <div>{{player.landesverband}} <span v-if="player.landesverband && player.verein">/</span> {{player.verein}}</div>
            <div>{{player.ak}}</div>
        </div>
        <div v-if="searchError?.code==='tooMany'" class="mb-5">
            <div class="pt-1 pb-2 error--text font-weight-bold">{{searchError.msg}}</div>
            <v-row v-for="(person, i) in searchError?.data" :key="i" class="border rounded mt-3"
                   align="center" no-gutters>
                <v-col class="grow pl-2">{{person.nachname}} {{person.vorname}}</v-col>
                <v-col class="shrink">
                    <v-btn text color="primary" @click="selectPlayer(person)">auswählen</v-btn>
                </v-col>
            </v-row>
        </div>
    <!-- not found-->
        <div v-if="searchError?.code==='notFound' || searchError?.code==='tooMany'">
            <div v-if="searchError?.code==='notFound'"
                 class="pt-1 pb-2 error--text font-weight-bold">{{searchError.msg}}</div>
            <v-btn @click="enterManually = !enterManually" color="primary" class="mb-2">
                manuell eingeben?
            </v-btn>
            <div v-if="enterManually" class="px-1">
                <v-text-field v-model="player.nachname" :rules="[rules.required]" label="Nachname" clearable/>
                <v-text-field v-model="player.vorname" :rules="[rules.required]" label="Vorname" clearable/>
                <v-text-field v-model="player.landesverband" :rules="[rules.required]" label="Landesverband" clearable/>
                <v-text-field v-model="player.verein" :rules="[rules.required]" label="Verein" clearable/>
                <v-text-field v-model="player.ak" :rules="[rules.required]" label="Verein" clearable/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "meisterschaftTeamEditCard",
    props: ['isSearching', 'player', 'searchError', 'rules', 'playerKey'],
    data: () => ({
        enterManually: false,
    }),
    methods: {
        selectPlayer(person){
            this.$emit('playerSelected', {player: this.playerKey, person: person})
        }
    },
    watch: {
        'player.passNumber'() { this.enterManually = false }
    }
}
</script>

<style scoped>
    .border{
        border: 1px solid grey;
        padding: 5px;
    }
</style>